import React from "react";
import { ConfirmModal } from "../../../../boxes/ConfirmModal/ConfirmModal";

const DeleteSmsModal = ({ onClose, onConfirm, smsIds, isConfirming }) => {
  return (
    <ConfirmModal
      isOpen
      onClose={onClose}
      title="Confirmation Required"
      onConfirm={onConfirm}
      onCancel={onClose}
      confirmTitle={"Yes"}
      cancelTitle={"No"}
      isConfirming={isConfirming}
    >
      {`Are you sure you want to delete ${
        smsIds.length === 1 ? "this conversation" : "these conversations"
      } ?`}
    </ConfirmModal>
  );
};

export default DeleteSmsModal;
